import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { Controller } from 'react-hook-form';
import { FormGroup, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import LabelText from './LableText';

const DatePickerCustom = ({ label = true, placeholder, register, control, errors, ...res }) => {
  const name = register.name;
  const labelText = LabelText(name);
  const placeholderText = !label || placeholder ? (placeholder ? placeholder : labelText) : placeholder ? placeholder : labelText;
  return (
    <FormGroup>
      {label && <Label for={name}>{labelText}</Label>}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <>
            <DatePicker {...res} placeholderText={placeholderText} {...register} onChange={(date) => field.onChange(date)} selected={field.value} />
            <ErrorMessage errors={errors} name={name} render={({ message }) => <span style={{ color: 'red' }}>{`${labelText} ${message}`}</span>} />
          </>
        )}
      />
    </FormGroup>
  );
};

export default DatePickerCustom;
